import React from 'react';

import { PTCMetadata } from '@api/ecommerce-xp';
import { CoreHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { Language } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$types';
import { getSavedTokenDataFromStorage } from '@helpers';
import { useServiceResponse } from '@store';

export const usePTCMetadata = (): PTCMetadata => {
	const contextId = getSavedTokenDataFromStorage<string>('contextId');
	const state = getSavedTokenDataFromStorage<string>('state');
	const language = getSavedTokenDataFromStorage('languageCode') as string;
	let languageCode = Language.pt;

	switch (language.toUpperCase()) {
		case 'ES':
			languageCode = Language.es;
			break;
		case 'EN':
			languageCode = Language.en;
			break;
		case 'FR':
			languageCode = Language.fr;
			break;
		default:
			languageCode = Language.pt;
	}

	const { retrieveContext } = useServiceResponse();

	return React.useMemo(
		(): PTCMetadata => ({
			application: '14',
			geo: '1',
			languageCode: languageCode.toUpperCase(),
			targetInfrastructure: '21',
			targetSystem: 'PTCorporate',
			...retrieveContext?.metadata,
			alias: CoreHelper.isNullOrEmpty(state) ? 'ecommerce' : 'ecommerce2',
			// sessionId: contextId || '34159d4f-85d8-4d4d-ac18-80ebd991e41c',
			sessionId: contextId || '',
		}),
		[contextId, languageCode, retrieveContext?.metadata, state]
	);
};
